import React from 'react';
// import PlanningClusterSummaryContainer from 'components/organisms/PlanningClusterSummaryContainer';
import PlanningFilterContainer from 'components/organisms/PlanningFilterContainer';
import PlanningChartsContainer from 'components/organisms/PlanningChartsContainer';
import PlanningGridContainer from 'components/organisms/PlanningGridContainer';
import FilterProvider from 'providers/Filter';
import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';

dayjs.extend(isoWeek);

const PlanejamentoPresentation = () => {
  const initialState = React.useMemo(
    () => ({
      plan: [{ label: dayjs().year().toString(), value: dayjs().year() }],
      week: [{ label: dayjs().isoWeek().toString(), value: dayjs().isoWeek() }],
    }),
    [],
  );

  const [updatedAt, setUpdatedAt] = React.useState<Date | null>(null);
  const [open, setOpen] = React.useState<boolean>(true);
  // const openClusterSummaryContainer = React.useMemo(() => open, [open]);
  const openGridContainer = React.useMemo(() => !open, [open]);

  return (
    <>
      <FilterProvider initialState={initialState}>
        <PlanningFilterContainer updatedAt={updatedAt} />
        <PlanningChartsContainer updatedAt={updatedAt} />
        {/* <PlanningClusterSummaryContainer
          open={openClusterSummaryContainer}
          onOpenOrClose={setOpen}
          updatedAt={updatedAt}
        /> */}
        <PlanningGridContainer
          open={openGridContainer}
          onOpenOrClose={setOpen}
          setUpdatedAt={setUpdatedAt}
        />
      </FilterProvider>
    </>
  );
};

export default PlanejamentoPresentation;
